import React, { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import Swal from "sweetalert2";
import { Button } from "react-bootstrap";

function DataGrid({ data, setShowModalEditRegion, setSelectedRegion }) {

  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "regionType",
        Header: "نوع ",
        minWidth: "100px",
      },
      {
        accessor: "name",
        Header: "نام ",
        minWidth: "100px",
      },
      {
        accessor: "englishName",
        Header: " نام انگلیسی",
        minWidth: "100px",
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* ویرایش */}
            <Button
              title="ویرایش"
              className="btn btn-light-primary btn-sm mr-2 btn-icon"
              onClick={() => {
                setSelectedRegion(row.original.id);
                setShowModalEditRegion(true);
              }}
            >
              <i className="far fa-edit text-small"></i>
            </Button>
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
